/* Tri-tennis: sorteerknop in de filterbalk (mobiel), terug-naar-boven-knop, video's ook op telefoon laten spelen */
(function () {
  function build() {
    var bar = document.querySelector('.tt-collection-page .facets-container');
    var src = document.getElementById('SortBy-mobile');
    if (!bar || !src) return;
    var wrap = bar.querySelector('.tt-msort');
    if (!wrap) {
      wrap = document.createElement('label');
      wrap.className = 'tt-msort';
      wrap.innerHTML = '<span class="tt-msort__label"></span><select class="tt-msort__select"></select>';
      var lab = document.querySelector('label[for="SortBy-mobile"]');
      var txt = lab ? lab.textContent.trim().replace(/:\s*$/, '') : 'Sort by';
      wrap.querySelector('.tt-msort__label').textContent = txt;
      wrap.querySelector('select').setAttribute('aria-label', txt);
      wrap.querySelector('select').addEventListener('change', function () {
        var s = document.getElementById('SortBy-mobile');
        if (!s) return;
        s.value = this.value;
        s.dispatchEvent(new Event('input', { bubbles: true }));
      });
      var count = bar.querySelector(':scope > .product-count');
      bar.insertBefore(wrap, count || null);
    }
    var sel = wrap.querySelector('select');
    if (sel.innerHTML !== src.innerHTML) sel.innerHTML = src.innerHTML;
    if (sel.value !== src.value) sel.value = src.value;
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; build(); });
  }
  function topButton() {
    if (document.querySelector('.tt-top')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tt-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(b);
    var ticking = false;
    function upd() { ticking = false; b.classList.toggle('is-visible', window.scrollY > 400); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
  /* Video's: ook op telefoon automatisch (gedempt) afspelen; lukt dat niet (bv. energiebesparingsmodus), dan bij de eerste aanraking */
  function videos() {
    var list = [].slice.call(document.querySelectorAll('video[autoplay], .tt-wrap__media video, .tt-video-media video'));
    if (!list.length) return;
    function shouldPlay(v) { return v.hasAttribute('autoplay') || v.classList.contains('is-active'); }
    function tryPlay() {
      list.forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
        if (v.paused && shouldPlay(v)) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    tryPlay();
    var kick = function () { tryPlay(); };
    ['touchend', 'click', 'keydown'].forEach(function (ev) { document.addEventListener(ev, kick, { once: true, passive: true }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) tryPlay(); }); });
      list.forEach(function (v) { io.observe(v); });
    }
  }
  function init() {
    topButton();
    videos();
    build();
    var aside = document.getElementById('main-collection-filters');
    if (aside && window.MutationObserver && !aside.__ttObs) { aside.__ttObs = true; new MutationObserver(queue).observe(aside, { childList: true, subtree: true }); }
  }
  /* "Why Tri-tennis"-kaarten: navy bij aanklikken */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('.tt-why__card');
    if (!c || c.tagName === 'A') return;
    var on = !c.classList.contains('is-on');
    document.querySelectorAll('.tt-why__card.is-on').forEach(function (x) { x.classList.remove('is-on'); });
    if (on) c.classList.add('is-on');
  });
  document.addEventListener('change', function (e) { if (e.target && e.target.id === 'SortBy-mobile') queue(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();